<template>
  <li class="lz-resource-card" :class="{ 'is-hidden-resource': isHidden }">
    <div class="lz-resource-admin" v-if="admin">
      <b-button size="sm" title="Edit" @click.stop="$emit('edit')">
        <b-icon-pencil scale="0.8"></b-icon-pencil>
      </b-button>
      <b-button
        size="sm"
        :title="isHidden ? 'Make visible' : 'Hide'"
        @click.stop="$emit('toggle')">
        <b-icon-eye-slash v-if="isHidden" scale="0.8"></b-icon-eye-slash>
        <b-icon-eye v-else scale="0.8"></b-icon-eye>
      </b-button>
    </div>
    <div class="lz-resource-title">{{ title }}</div>
    <ul class="lz-resource-actions" v-if="$slots.default">
      <slot></slot>
    </ul>
  </li>
</template>

<script>
export default {
  // One resource tile. Shared by the Useful Links, Training Modules and
  // Documents and Forms tabs, which all render the same card with a different
  // set of actions - those are passed in through the default slot as
  // <resource-action> children.
  name: 'HomeResourceCard',
  props: {
    title: {
      type: String,
      required: true
    },
    isHidden: {
      type: Boolean,
      required: false,
      default: false
    },
    admin: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
